import { invariant } from '@seen/core/invariant'
import { createContext, useContext } from 'react'

export interface FacesheetCardContextValue {
  // Published on FacesheetCardLabel so FacesheetCardCollapseTrigger — a bare
  // triangle with no text of its own — can name itself after the section.
  labelId: string
  // Whether the card is a Collapsible root at all: a card with something to
  // fold away. A card with no content shows no triangle and its header row is
  // not a toggle.
  collapsible: boolean
  // True while the card's content is showing. Always true when the card is not
  // collapsible.
  open: boolean
}

export const FacesheetCardContext =
  createContext<FacesheetCardContextValue | null>(null)

export function useFacesheetCard(): FacesheetCardContextValue {
  const value = useContext(FacesheetCardContext)
  invariant(value, 'Facesheet card slots must render inside FacesheetCard')
  return value
}
